/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-google-font-info.ts
 * Generated on: 2026-02-05T18:10:40.765Z
 *
 * This file contains a minimal font list for browser use.
 * For full font metadata, use the /api/fonts/:name endpoint.
 */

/**
 * Minimal font information for browser UI
 * Contains 256 Google Fonts
 */
export const GOOGLE_FONTS_LIST = [
  {
    importName: "Roboto",
    fontFamily: "Roboto",
    previewUrl: "Roboto",
  },
  {
    importName: "OpenSans",
    fontFamily: "Open Sans",
    previewUrl: "Open+Sans",
  },
  {
    importName: "Lato",
    fontFamily: "Lato",
    previewUrl: "Lato",
  },
  {
    importName: "Montserrat",
    fontFamily: "Montserrat",
    previewUrl: "Montserrat",
  },
  {
    importName: "Poppins",
    fontFamily: "Poppins",
    previewUrl: "Poppins",
  },
  {
    importName: "Inter",
    fontFamily: "Inter",
    previewUrl: "Inter",
  },
  {
    importName: "Raleway",
    fontFamily: "Raleway",
    previewUrl: "Raleway",
  },
  {
    importName: "Ubuntu",
    fontFamily: "Ubuntu",
    previewUrl: "Ubuntu",
  },
  {
    importName: "Nunito",
    fontFamily: "Nunito",
    previewUrl: "Nunito",
  },
  {
    importName: "NunitoSans",
    fontFamily: "Nunito Sans",
    previewUrl: "Nunito+Sans",
  },
  {
    importName: "WorkSans",
    fontFamily: "Work Sans",
    previewUrl: "Work+Sans",
  },
  {
    importName: "Quicksand",
    fontFamily: "Quicksand",
    previewUrl: "Quicksand",
  },
  {
    importName: "Rubik",
    fontFamily: "Rubik",
    previewUrl: "Rubik",
  },
  {
    importName: "SourceSans3",
    fontFamily: "Source Sans Three",
    previewUrl: "Source+Sans+3",
  },
  {
    importName: "DMSans",
    fontFamily: "DM Sans",
    previewUrl: "DM+Sans",
  },
  {
    importName: "Mulish",
    fontFamily: "Mulish",
    previewUrl: "Mulish",
  },
  {
    importName: "Manrope",
    fontFamily: "Manrope",
    previewUrl: "Manrope",
  },
  {
    importName: "Outfit",
    fontFamily: "Outfit",
    previewUrl: "Outfit",
  },
  {
    importName: "PlusJakartaSans",
    fontFamily: "Plus Jakarta Sans",
    previewUrl: "Plus+Jakarta+Sans",
  },
  {
    importName: "Lexend",
    fontFamily: "Lexend",
    previewUrl: "Lexend",
  },
  {
    importName: "PlayfairDisplay",
    fontFamily: "Playfair Display",
    previewUrl: "Playfair+Display",
  },
  {
    importName: "Merriweather",
    fontFamily: "Merriweather",
    previewUrl: "Merriweather",
  },
  {
    importName: "Lora",
    fontFamily: "Lora",
    previewUrl: "Lora",
  },
  {
    importName: "PTSerif",
    fontFamily: "PT Serif",
    previewUrl: "PT+Serif",
  },
  {
    importName: "NotoSerif",
    fontFamily: "Noto Serif",
    previewUrl: "Noto+Serif",
  },
  {
    importName: "EBGaramond",
    fontFamily: "EB Garamond",
    previewUrl: "EB+Garamond",
  },
  {
    importName: "LibreBaskerville",
    fontFamily: "Libre Baskerville",
    previewUrl: "Libre+Baskerville",
  },
  {
    importName: "CrimsonText",
    fontFamily: "Crimson Text",
    previewUrl: "Crimson+Text",
  },
  {
    importName: "Bitter",
    fontFamily: "Bitter",
    previewUrl: "Bitter",
  },
  {
    importName: "SourceSerif4",
    fontFamily: "Source Serif Four",
    previewUrl: "Source+Serif+4",
  },
  {
    importName: "BebasNeue",
    fontFamily: "Bebas Neue",
    previewUrl: "Bebas+Neue",
  },
  {
    importName: "Pacifico",
    fontFamily: "Pacifico",
    previewUrl: "Pacifico",
  },
  {
    importName: "DancingScript",
    fontFamily: "Dancing Script",
    previewUrl: "Dancing+Script",
  },
  {
    importName: "Comfortaa",
    fontFamily: "Comfortaa",
    previewUrl: "Comfortaa",
  },
  {
    importName: "Lobster",
    fontFamily: "Lobster",
    previewUrl: "Lobster",
  },
  {
    importName: "Caveat",
    fontFamily: "Caveat",
    previewUrl: "Caveat",
  },
  {
    importName: "Anton",
    fontFamily: "Anton",
    previewUrl: "Anton",
  },
  {
    importName: "Righteous",
    fontFamily: "Righteous",
    previewUrl: "Righteous",
  },
  {
    importName: "Satisfy",
    fontFamily: "Satisfy",
    previewUrl: "Satisfy",
  },
  {
    importName: "GreatVibes",
    fontFamily: "Great Vibes",
    previewUrl: "Great+Vibes",
  },
  {
    importName: "RobotoMono",
    fontFamily: "Roboto Mono",
    previewUrl: "Roboto+Mono",
  },
  {
    importName: "FiraCode",
    fontFamily: "Fira Code",
    previewUrl: "Fira+Code",
  },
  {
    importName: "SourceCodePro",
    fontFamily: "Source Code Pro",
    previewUrl: "Source+Code+Pro",
  },
  {
    importName: "JetBrainsMono",
    fontFamily: "JetBrains Mono",
    previewUrl: "JetBrains+Mono",
  },
  {
    importName: "Inconsolata",
    fontFamily: "Inconsolata",
    previewUrl: "Inconsolata",
  },
  {
    importName: "SpaceMono",
    fontFamily: "Space Mono",
    previewUrl: "Space+Mono",
  },
  {
    importName: "IBMPlexMono",
    fontFamily: "IBM Plex Mono",
    previewUrl: "IBM+Plex+Mono",
  },
  {
    importName: "CourierPrime",
    fontFamily: "Courier Prime",
    previewUrl: "Courier+Prime",
  },
  {
    importName: "RedHatMono",
    fontFamily: "Red Hat Mono",
    previewUrl: "Red+Hat+Mono",
  },
  {
    importName: "DMMono",
    fontFamily: "DM Mono",
    previewUrl: "DM+Mono",
  },
  {
    importName: "Barlow",
    fontFamily: "Barlow",
    previewUrl: "Barlow",
  },
  {
    importName: "Hind",
    fontFamily: "Hind",
    previewUrl: "Hind",
  },
  {
    importName: "JosefinSans",
    fontFamily: "Josefin Sans",
    previewUrl: "Josefin+Sans",
  },
  {
    importName: "Arimo",
    fontFamily: "Arimo",
    previewUrl: "Arimo",
  },
  {
    importName: "Dosis",
    fontFamily: "Dosis",
    previewUrl: "Dosis",
  },
  {
    importName: "PTSans",
    fontFamily: "PT Sans",
    previewUrl: "PT+Sans",
  },
  {
    importName: "LibreFranklin",
    fontFamily: "Libre Franklin",
    previewUrl: "Libre+Franklin",
  },
  {
    importName: "Karla",
    fontFamily: "Karla",
    previewUrl: "Karla",
  },
  {
    importName: "Cabin",
    fontFamily: "Cabin",
    previewUrl: "Cabin",
  },
  {
    importName: "Oxygen",
    fontFamily: "Oxygen",
    previewUrl: "Oxygen",
  },
  {
    importName: "Overpass",
    fontFamily: "Overpass",
    previewUrl: "Overpass",
  },
  {
    importName: "FiraSans",
    fontFamily: "Fira Sans",
    previewUrl: "Fira+Sans",
  },
  {
    importName: "MavenPro",
    fontFamily: "Maven Pro",
    previewUrl: "Maven+Pro",
  },
  {
    importName: "Cairo",
    fontFamily: "Cairo",
    previewUrl: "Cairo",
  },
  {
    importName: "Exo2",
    fontFamily: "Exo Two",
    previewUrl: "Exo+2",
  },
  {
    importName: "Signika",
    fontFamily: "Signika",
    previewUrl: "Signika",
  },
  {
    importName: "Assistant",
    fontFamily: "Assistant",
    previewUrl: "Assistant",
  },
  {
    importName: "PublicSans",
    fontFamily: "Public Sans",
    previewUrl: "Public+Sans",
  },
  {
    importName: "RedHatDisplay",
    fontFamily: "Red Hat Display",
    previewUrl: "Red+Hat+Display",
  },
  {
    importName: "Epilogue",
    fontFamily: "Epilogue",
    previewUrl: "Epilogue",
  },
  {
    importName: "SpaceGrotesk",
    fontFamily: "Space Grotesk",
    previewUrl: "Space+Grotesk",
  },
  {
    importName: "Sora",
    fontFamily: "Sora",
    previewUrl: "Sora",
  },
  {
    importName: "Urbanist",
    fontFamily: "Urbanist",
    previewUrl: "Urbanist",
  },
  {
    importName: "Figtree",
    fontFamily: "Figtree",
    previewUrl: "Figtree",
  },
  {
    importName: "SchibstedGrotesk",
    fontFamily: "Schibsted Grotesk",
    previewUrl: "Schibsted+Grotesk",
  },
  {
    importName: "Onest",
    fontFamily: "Onest",
    previewUrl: "Onest",
  },
  {
    importName: "Archivo",
    fontFamily: "Archivo",
    previewUrl: "Archivo",
  },
  {
    importName: "NotoSansJP",
    fontFamily: "Noto Sans JP",
    previewUrl: "Noto+Sans+JP",
  },
  {
    importName: "TitilliumWeb",
    fontFamily: "Titillium Web",
    previewUrl: "Titillium+Web",
  },
  {
    importName: "Commissioner",
    fontFamily: "Commissioner",
    previewUrl: "Commissioner",
  },
  {
    importName: "BeVietnamPro",
    fontFamily: "Be Vietnam Pro",
    previewUrl: "Be+Vietnam+Pro",
  },
  {
    importName: "Jost",
    fontFamily: "Jost",
    previewUrl: "Jost",
  },
  {
    importName: "Chivo",
    fontFamily: "Chivo",
    previewUrl: "Chivo",
  },
  {
    importName: "Heebo",
    fontFamily: "Heebo",
    previewUrl: "Heebo",
  },
  {
    importName: "Mukta",
    fontFamily: "Mukta",
    previewUrl: "Mukta",
  },
  {
    importName: "Kanit",
    fontFamily: "Kanit",
    previewUrl: "Kanit",
  },
  {
    importName: "IBMPlexSans",
    fontFamily: "IBM Plex Sans",
    previewUrl: "IBM+Plex+Sans",
  },
  {
    importName: "BarlowCondensed",
    fontFamily: "Barlow Condensed",
    previewUrl: "Barlow+Condensed",
  },
  {
    importName: "RobotoCondensed",
    fontFamily: "Roboto Condensed",
    previewUrl: "Roboto+Condensed",
  },
  {
    importName: "Oswald",
    fontFamily: "Oswald",
    previewUrl: "Oswald",
  },
  {
    importName: "NotoSans",
    fontFamily: "Noto Sans",
    previewUrl: "Noto+Sans",
  },
  {
    importName: "RobotoSlab",
    fontFamily: "Roboto Slab",
    previewUrl: "Roboto+Slab",
  },
  {
    importName: "Asap",
    fontFamily: "Asap",
    previewUrl: "Asap",
  },
  {
    importName: "ZillaSlab",
    fontFamily: "Zilla Slab",
    previewUrl: "Zilla+Slab",
  },
  {
    importName: "CormorantGaramond",
    fontFamily: "Cormorant Garamond",
    previewUrl: "Cormorant+Garamond",
  },
  {
    importName: "Spectral",
    fontFamily: "Spectral",
    previewUrl: "Spectral",
  },
  {
    importName: "Arvo",
    fontFamily: "Arvo",
    previewUrl: "Arvo",
  },
  {
    importName: "Domine",
    fontFamily: "Domine",
    previewUrl: "Domine",
  },
  {
    importName: "Vollkorn",
    fontFamily: "Vollkorn",
    previewUrl: "Vollkorn",
  },
  {
    importName: "Alegreya",
    fontFamily: "Alegreya",
    previewUrl: "Alegreya",
  },
  {
    importName: "CreteRound",
    fontFamily: "Crete Round",
    previewUrl: "Crete+Round",
  },
  {
    importName: "Rokkitt",
    fontFamily: "Rokkitt",
    previewUrl: "Rokkitt",
  },
  {
    importName: "Slabo27px",
    fontFamily: "Slabo TwoSevenpx",
    previewUrl: "Slabo+27px",
  },
  {
    importName: "NoticiaText",
    fontFamily: "Noticia Text",
    previewUrl: "Noticia+Text",
  },
  {
    importName: "FrankRuhlLibre",
    fontFamily: "Frank Ruhl Libre",
    previewUrl: "Frank+Ruhl+Libre",
  },
  {
    importName: "OldStandardTT",
    fontFamily: "Old Standard TT",
    previewUrl: "Old+Standard+TT",
  },
  {
    importName: "AbrilFatface",
    fontFamily: "Abril Fatface",
    previewUrl: "Abril+Fatface",
  },
  {
    importName: "SecularOne",
    fontFamily: "Secular One",
    previewUrl: "Secular+One",
  },
  {
    importName: "Fredoka",
    fontFamily: "Fredoka",
    previewUrl: "Fredoka",
  },
  {
    importName: "Bungee",
    fontFamily: "Bungee",
    previewUrl: "Bungee",
  },
  {
    importName: "PassionOne",
    fontFamily: "Passion One",
    previewUrl: "Passion+One",
  },
  {
    importName: "RussoOne",
    fontFamily: "Russo One",
    previewUrl: "Russo+One",
  },
  {
    importName: "PermanentMarker",
    fontFamily: "Permanent Marker",
    previewUrl: "Permanent+Marker",
  },
  {
    importName: "Cookie",
    fontFamily: "Cookie",
    previewUrl: "Cookie",
  },
  {
    importName: "KaushanScript",
    fontFamily: "Kaushan Script",
    previewUrl: "Kaushan+Script",
  },
  {
    importName: "ShadowsIntoLight",
    fontFamily: "Shadows Into Light",
    previewUrl: "Shadows+Into+Light",
  },
  {
    importName: "AmaticSC",
    fontFamily: "Amatic SC",
    previewUrl: "Amatic+SC",
  },
  {
    importName: "Sacramento",
    fontFamily: "Sacramento",
    previewUrl: "Sacramento",
  },
  {
    importName: "Handlee",
    fontFamily: "Handlee",
    previewUrl: "Handlee",
  },
  {
    importName: "PatrickHand",
    fontFamily: "Patrick Hand",
    previewUrl: "Patrick+Hand",
  },
  {
    importName: "GloriaHallelujah",
    fontFamily: "Gloria Hallelujah",
    previewUrl: "Gloria+Hallelujah",
  },
  {
    importName: "IndieFlower",
    fontFamily: "Indie Flower",
    previewUrl: "Indie+Flower",
  },
  {
    importName: "ArchitectsDaughter",
    fontFamily: "Architects Daughter",
    previewUrl: "Architects+Daughter",
  },
  {
    importName: "Courgette",
    fontFamily: "Courgette",
    previewUrl: "Courgette",
  },
  {
    importName: "Kalam",
    fontFamily: "Kalam",
    previewUrl: "Kalam",
  },
  {
    importName: "UbuntuMono",
    fontFamily: "Ubuntu Mono",
    previewUrl: "Ubuntu+Mono",
  },
  {
    importName: "AnonymousPro",
    fontFamily: "Anonymous Pro",
    previewUrl: "Anonymous+Pro",
  },
  {
    importName: "VT323",
    fontFamily: "VTThreeTwoThree",
    previewUrl: "VT323",
  },
  {
    importName: "OverpassMono",
    fontFamily: "Overpass Mono",
    previewUrl: "Overpass+Mono",
  },
  {
    importName: "MajorMonoDisplay",
    fontFamily: "Major Mono Display",
    previewUrl: "Major+Mono+Display",
  },
  {
    importName: "ShareTechMono",
    fontFamily: "Share Tech Mono",
    previewUrl: "Share+Tech+Mono",
  },
  {
    importName: "NovaMono",
    fontFamily: "Nova Mono",
    previewUrl: "Nova+Mono",
  },
  {
    importName: "CutiveMono",
    fontFamily: "Cutive Mono",
    previewUrl: "Cutive+Mono",
  },
  {
    importName: "Cousine",
    fontFamily: "Cousine",
    previewUrl: "Cousine",
  },
  {
    importName: "B612Mono",
    fontFamily: "BSixOneTwo Mono",
    previewUrl: "B612+Mono",
  },
  {
    importName: "Saira",
    fontFamily: "Saira",
    previewUrl: "Saira",
  },
  {
    importName: "Prompt",
    fontFamily: "Prompt",
    previewUrl: "Prompt",
  },
  {
    importName: "MPLUSRounded1c",
    fontFamily: "M PLUS Rounded Onec",
    previewUrl: "M+PLUS+Rounded+1c",
  },
  {
    importName: "VarelaRound",
    fontFamily: "Varela Round",
    previewUrl: "Varela+Round",
  },
  {
    importName: "Catamaran",
    fontFamily: "Catamaran",
    previewUrl: "Catamaran",
  },
  {
    importName: "EncodeSans",
    fontFamily: "Encode Sans",
    previewUrl: "Encode+Sans",
  },
  {
    importName: "Exo",
    fontFamily: "Exo",
    previewUrl: "Exo",
  },
  {
    importName: "LeagueSpartan",
    fontFamily: "League Spartan",
    previewUrl: "League+Spartan",
  },
  {
    importName: "Rajdhani",
    fontFamily: "Rajdhani",
    previewUrl: "Rajdhani",
  },
  {
    importName: "Tajawal",
    fontFamily: "Tajawal",
    previewUrl: "Tajawal",
  },
  {
    importName: "Almarai",
    fontFamily: "Almarai",
    previewUrl: "Almarai",
  },
  {
    importName: "GothicA1",
    fontFamily: "Gothic AOne",
    previewUrl: "Gothic+A1",
  },
  {
    importName: "NanumGothic",
    fontFamily: "Nanum Gothic",
    previewUrl: "Nanum+Gothic",
  },
  {
    importName: "Sarabun",
    fontFamily: "Sarabun",
    previewUrl: "Sarabun",
  },
  {
    importName: "ChakraPetch",
    fontFamily: "Chakra Petch",
    previewUrl: "Chakra+Petch",
  },
  {
    importName: "BaiJamjuree",
    fontFamily: "Bai Jamjuree",
    previewUrl: "Bai+Jamjuree",
  },
  {
    importName: "Mitr",
    fontFamily: "Mitr",
    previewUrl: "Mitr",
  },
  {
    importName: "Athiti",
    fontFamily: "Athiti",
    previewUrl: "Athiti",
  },
  {
    importName: "Mada",
    fontFamily: "Mada",
    previewUrl: "Mada",
  },
  {
    importName: "ElMessiri",
    fontFamily: "El Messiri",
    previewUrl: "El+Messiri",
  },
  {
    importName: "Amiri",
    fontFamily: "Amiri",
    previewUrl: "Amiri",
  },
  {
    importName: "MarkaziText",
    fontFamily: "Markazi Text",
    previewUrl: "Markazi+Text",
  },
  {
    importName: "Harmattan",
    fontFamily: "Harmattan",
    previewUrl: "Harmattan",
  },
  {
    importName: "Lalezar",
    fontFamily: "Lalezar",
    previewUrl: "Lalezar",
  },
  {
    importName: "ScheherazadeNew",
    fontFamily: "Scheherazade New",
    previewUrl: "Scheherazade+New",
  },
  {
    importName: "Vazirmatn",
    fontFamily: "Vazirmatn",
    previewUrl: "Vazirmatn",
  },
  {
    importName: "ReadexPro",
    fontFamily: "Readex Pro",
    previewUrl: "Readex+Pro",
  },
  {
    importName: "Alexandria",
    fontFamily: "Alexandria",
    previewUrl: "Alexandria",
  },
  {
    importName: "ReemKufi",
    fontFamily: "Reem Kufi",
    previewUrl: "Reem+Kufi",
  },
  {
    importName: "Kufam",
    fontFamily: "Kufam",
    previewUrl: "Kufam",
  },
  {
    importName: "ArefRuqaa",
    fontFamily: "Aref Ruqaa",
    previewUrl: "Aref+Ruqaa",
  },
  {
    importName: "Mirza",
    fontFamily: "Mirza",
    previewUrl: "Mirza",
  },
  {
    importName: "Rasa",
    fontFamily: "Rasa",
    previewUrl: "Rasa",
  },
  {
    importName: "Yrsa",
    fontFamily: "Yrsa",
    previewUrl: "Yrsa",
  },
  {
    importName: "Teko",
    fontFamily: "Teko",
    previewUrl: "Teko",
  },
  {
    importName: "Yantramanav",
    fontFamily: "Yantramanav",
    previewUrl: "Yantramanav",
  },
  {
    importName: "Khand",
    fontFamily: "Khand",
    previewUrl: "Khand",
  },
  {
    importName: "PragatiNarrow",
    fontFamily: "Pragati Narrow",
    previewUrl: "Pragati+Narrow",
  },
  {
    importName: "Laila",
    fontFamily: "Laila",
    previewUrl: "Laila",
  },
  {
    importName: "Eczar",
    fontFamily: "Eczar",
    previewUrl: "Eczar",
  },
  {
    importName: "Martel",
    fontFamily: "Martel",
    previewUrl: "Martel",
  },
  {
    importName: "MartelSans",
    fontFamily: "Martel Sans",
    previewUrl: "Martel+Sans",
  },
  {
    importName: "Modak",
    fontFamily: "Modak",
    previewUrl: "Modak",
  },
  {
    importName: "Pavanam",
    fontFamily: "Pavanam",
    previewUrl: "Pavanam",
  },
  {
    importName: "Ramabhadra",
    fontFamily: "Ramabhadra",
    previewUrl: "Ramabhadra",
  },
  {
    importName: "Halant",
    fontFamily: "Halant",
    previewUrl: "Halant",
  },
  {
    importName: "Share",
    fontFamily: "Share",
    previewUrl: "Share",
  },
  {
    importName: "Karma",
    fontFamily: "Karma",
    previewUrl: "Karma",
  },
  {
    importName: "ArchivoBlack",
    fontFamily: "Archivo Black",
    previewUrl: "Archivo+Black",
  },
  {
    importName: "Coda",
    fontFamily: "Coda",
    previewUrl: "Coda",
  },
  {
    importName: "BungeeInline",
    fontFamily: "Bungee Inline",
    previewUrl: "Bungee+Inline",
  },
  {
    importName: "Orbitron",
    fontFamily: "Orbitron",
    previewUrl: "Orbitron",
  },
  {
    importName: "BlackOpsOne",
    fontFamily: "Black Ops One",
    previewUrl: "Black+Ops+One",
  },
  {
    importName: "Monoton",
    fontFamily: "Monoton",
    previewUrl: "Monoton",
  },
  {
    importName: "PressStart2P",
    fontFamily: "Press Start TwoP",
    previewUrl: "Press+Start+2P",
  },
  {
    importName: "BungeeShade",
    fontFamily: "Bungee Shade",
    previewUrl: "Bungee+Shade",
  },
  {
    importName: "RubikMonoOne",
    fontFamily: "Rubik Mono One",
    previewUrl: "Rubik+Mono+One",
  },
  {
    importName: "Audiowide",
    fontFamily: "Audiowide",
    previewUrl: "Audiowide",
  },
  {
    importName: "TiltWarp",
    fontFamily: "Tilt Warp",
    previewUrl: "Tilt+Warp",
  },
  {
    importName: "Gruppo",
    fontFamily: "Gruppo",
    previewUrl: "Gruppo",
  },
  {
    importName: "PoiretOne",
    fontFamily: "Poiret One",
    previewUrl: "Poiret+One",
  },
  {
    importName: "Forum",
    fontFamily: "Forum",
    previewUrl: "Forum",
  },
  {
    importName: "Syncopate",
    fontFamily: "Syncopate",
    previewUrl: "Syncopate",
  },
  {
    importName: "Megrim",
    fontFamily: "Megrim",
    previewUrl: "Megrim",
  },
  {
    importName: "JuliusSansOne",
    fontFamily: "Julius Sans One",
    previewUrl: "Julius+Sans+One",
  },
  {
    importName: "AdventPro",
    fontFamily: "Advent Pro",
    previewUrl: "Advent+Pro",
  },
  {
    importName: "WireOne",
    fontFamily: "Wire One",
    previewUrl: "Wire+One",
  },
  {
    importName: "NixieOne",
    fontFamily: "Nixie One",
    previewUrl: "Nixie+One",
  },
  {
    importName: "AnekMalayalam",
    fontFamily: "Anek Malayalam",
    previewUrl: "Anek+Malayalam",
  },
  {
    importName: "LibreCaslonText",
    fontFamily: "Libre Caslon Text",
    previewUrl: "Libre+Caslon+Text",
  },
  {
    importName: "BodoniModa",
    fontFamily: "Bodoni Moda",
    previewUrl: "Bodoni+Moda",
  },
  {
    importName: "Fraunces",
    fontFamily: "Fraunces",
    previewUrl: "Fraunces",
  },
  {
    importName: "Literata",
    fontFamily: "Literata",
    previewUrl: "Literata",
  },
  {
    importName: "Newsreader",
    fontFamily: "Newsreader",
    previewUrl: "Newsreader",
  },
  {
    importName: "Petrona",
    fontFamily: "Petrona",
    previewUrl: "Petrona",
  },
  {
    importName: "Piazzolla",
    fontFamily: "Piazzolla",
    previewUrl: "Piazzolla",
  },
  {
    importName: "Castoro",
    fontFamily: "Castoro",
    previewUrl: "Castoro",
  },
  {
    importName: "Hahmlet",
    fontFamily: "Hahmlet",
    previewUrl: "Hahmlet",
  },
  {
    importName: "Texturina",
    fontFamily: "Texturina",
    previewUrl: "Texturina",
  },
  {
    importName: "Syne",
    fontFamily: "Syne",
    previewUrl: "Syne",
  },
  {
    importName: "Brygada1918",
    fontFamily: "Brygada OneNineOneEight",
    previewUrl: "Brygada+1918",
  },
  {
    importName: "Varta",
    fontFamily: "Varta",
    previewUrl: "Varta",
  },
  {
    importName: "Grandstander",
    fontFamily: "Grandstander",
    previewUrl: "Grandstander",
  },
  {
    importName: "RedRose",
    fontFamily: "Red Rose",
    previewUrl: "Red+Rose",
  },
  {
    importName: "AndadaPro",
    fontFamily: "Andada Pro",
    previewUrl: "Andada+Pro",
  },
  {
    importName: "Trispace",
    fontFamily: "Trispace",
    previewUrl: "Trispace",
  },
  {
    importName: "KumbhSans",
    fontFamily: "Kumbh Sans",
    previewUrl: "Kumbh+Sans",
  },
  {
    importName: "Truculenta",
    fontFamily: "Truculenta",
    previewUrl: "Truculenta",
  },
  {
    importName: "Belleza",
    fontFamily: "Belleza",
    previewUrl: "Belleza",
  },
  {
    importName: "DidactGothic",
    fontFamily: "Didact Gothic",
    previewUrl: "Didact+Gothic",
  },
  {
    importName: "Questrial",
    fontFamily: "Questrial",
    previewUrl: "Questrial",
  },
  {
    importName: "Monda",
    fontFamily: "Monda",
    previewUrl: "Monda",
  },
  {
    importName: "LexendDeca",
    fontFamily: "Lexend Deca",
    previewUrl: "Lexend+Deca",
  },
  {
    importName: "RedHatText",
    fontFamily: "Red Hat Text",
    previewUrl: "Red+Hat+Text",
  },
  {
    importName: "Alata",
    fontFamily: "Alata",
    previewUrl: "Alata",
  },
  {
    importName: "AsapCondensed",
    fontFamily: "Asap Condensed",
    previewUrl: "Asap+Condensed",
  },
  {
    importName: "Mandali",
    fontFamily: "Mandali",
    previewUrl: "Mandali",
  },
  {
    importName: "Tomorrow",
    fontFamily: "Tomorrow",
    previewUrl: "Tomorrow",
  },
  {
    importName: "DarkerGrotesque",
    fontFamily: "Darker Grotesque",
    previewUrl: "Darker+Grotesque",
  },
  {
    importName: "DMSerifDisplay",
    fontFamily: "DM Serif Display",
    previewUrl: "DM+Serif+Display",
  },
  {
    importName: "Gelasio",
    fontFamily: "Gelasio",
    previewUrl: "Gelasio",
  },
  {
    importName: "InriaSerif",
    fontFamily: "Inria Serif",
    previewUrl: "Inria+Serif",
  },
  {
    importName: "CrimsonPro",
    fontFamily: "Crimson Pro",
    previewUrl: "Crimson+Pro",
  },
  {
    importName: "SawarabiGothic",
    fontFamily: "Sawarabi Gothic",
    previewUrl: "Sawarabi+Gothic",
  },
  {
    importName: "KosugiMaru",
    fontFamily: "Kosugi Maru",
    previewUrl: "Kosugi+Maru",
  },
  {
    importName: "MPLUS1p",
    fontFamily: "M PLUS Onep",
    previewUrl: "M+PLUS+1p",
  },
  {
    importName: "ZenMaruGothic",
    fontFamily: "Zen Maru Gothic",
    previewUrl: "Zen+Maru+Gothic",
  },
  {
    importName: "StickNoBills",
    fontFamily: "Stick No Bills",
    previewUrl: "Stick+No+Bills",
  },
  {
    importName: "NotoSansDevanagari",
    fontFamily: "Noto Sans Devanagari",
    previewUrl: "Noto+Sans+Devanagari",
  },
  {
    importName: "NotoSansTamil",
    fontFamily: "Noto Sans Tamil",
    previewUrl: "Noto+Sans+Tamil",
  },
  {
    importName: "NotoSansTelugu",
    fontFamily: "Noto Sans Telugu",
    previewUrl: "Noto+Sans+Telugu",
  },
  {
    importName: "NotoSansBengali",
    fontFamily: "Noto Sans Bengali",
    previewUrl: "Noto+Sans+Bengali",
  },
  {
    importName: "NotoSansGujarati",
    fontFamily: "Noto Sans Gujarati",
    previewUrl: "Noto+Sans+Gujarati",
  },
  {
    importName: "NotoSansKannada",
    fontFamily: "Noto Sans Kannada",
    previewUrl: "Noto+Sans+Kannada",
  },
  {
    importName: "NotoSansMalayalam",
    fontFamily: "Noto Sans Malayalam",
    previewUrl: "Noto+Sans+Malayalam",
  },
  {
    importName: "NotoSansGurmukhi",
    fontFamily: "Noto Sans Gurmukhi",
    previewUrl: "Noto+Sans+Gurmukhi",
  },
  {
    importName: "NotoSansOriya",
    fontFamily: "Noto Sans Oriya",
    previewUrl: "Noto+Sans+Oriya",
  },
  {
    importName: "NotoNastaliqUrdu",
    fontFamily: "Noto Nastaliq Urdu",
    previewUrl: "Noto+Nastaliq+Urdu",
  },
  {
    importName: "NotoSansArabic",
    fontFamily: "Noto Sans Arabic",
    previewUrl: "Noto+Sans+Arabic",
  },
  {
    importName: "NotoSansSC",
    fontFamily: "Noto Sans SC",
    previewUrl: "Noto+Sans+SC",
  },
  {
    importName: "NotoSansKR",
    fontFamily: "Noto Sans KR",
    previewUrl: "Noto+Sans+KR",
  },
];

/**
 * Type definition for font list items
 */
export type GoogleFontListItem = (typeof GOOGLE_FONTS_LIST)[number];
